import { Directive, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { GenericService } from '@services/generic.service';
import { LocatorService } from '@app/shared/services';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { enumIsfCodeStep } from '@app/modules/isf/enums';

@Directive()
export abstract class CbyIsfStepComponent implements OnInit, OnDestroy {
  @Input() get isValid(): boolean {
    return this._isValid;
  }

  set isValid(val: boolean) {
    this._isValid = val;
    this.isOldValid = val;
    this.isValidChange.emit(this.isValid);
  }
  @Output() public isNext: EventEmitter<boolean | enumIsfCodeStep> = new EventEmitter<boolean>();
  @Output() public isSkip: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public isContinue: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() public isValidChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public isOldValid = false;

  public subscription: Subscription[] = [];

  public isfRoute: string = 'isf/';

  public genericServiceRef: GenericService;
  public routerRef: Router;

  private _isValid = false;

  constructor() {
    this.genericServiceRef = LocatorService.injector.get(GenericService);
    this.routerRef = LocatorService.injector.get(Router);
  }

  public ngOnInit(): void {
    this.setGreenHeader();

    this.subscription.push(
      this.routerRef.events.subscribe((val: RouterEvent) => {
        // don't set to false, because it's already set in header.component.ts
        if (val instanceof NavigationEnd && val.url.includes(this.isfRoute)) {
          this.setGreenHeader();
        }
      }),
    );

    this.isValid = true;
    this.subscription.push(
      this.isContinue.subscribe(() => {
        this.continue();
      }),
      this.isSkip.subscribe(() => {
        this.skip();
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.forEach((e) => {
      e.unsubscribe();
    });
  }

  public next(stepNumber?: enumIsfCodeStep): void {
    if (stepNumber) {
      this.isNext.emit(stepNumber);
    } else {
      this.isNext.emit(true);
    }
  }

  public abstract continue(): void;

  public abstract skip(): void;

  public abstract checkValidState(): void;

  private setGreenHeader(): void {
    this.genericServiceRef.isGreenHeader = true;
  }
}
